import { ParsedAppliesTo, CascaderOption } from 'components/promo_codes/promo_codes.types';

export function parseAppliesTo(appliesTo: number[][], cascaderOptions: CascaderOption[]): ParsedAppliesTo[] {
  const result: ParsedAppliesTo[] = [];

  appliesTo.forEach(item => {
    const storeId = item[0]; // First element is the storeId
    let giftCardTypeIds = item.slice(1); // Remaining elements are giftCardTypeIds

    // If only storeId is provided and there are no giftCardTypeIds in the sub-array
    if (giftCardTypeIds?.length === 0) {
      // Find all giftCardTypeIds for the storeId from cascaderOptions
      const store = cascaderOptions.find(option => option.value === storeId);
      if (store && store.children) {
        giftCardTypeIds = store.children.map(child => child.value as number);
      }
    }

    // Check if storeId already exists in the result array
    const existingStore = result.find(store => store.storeId === storeId);

    if (existingStore) {
      // Merge the giftCardTypeIds if storeId already exists
      existingStore.giftCardTypeIds = Array.from(new Set([...existingStore.giftCardTypeIds, ...giftCardTypeIds]));
    } else {
      // Add a new storeId and giftCardTypeIds to the result
      result.push({ storeId, giftCardTypeIds });
    }
  });

  return result;
}

export function parseAppliesToForDefaultValue(appliesTo: ParsedAppliesTo[]): (number | string)[][] {
  const defaultValue: (number | string)[][] = [];

  appliesTo.forEach(({ storeId, giftCardTypeIds }) => {
    if (giftCardTypeIds?.length > 0) {
      // Add paths for each gift card type ID under the store
      giftCardTypeIds.forEach(giftCardTypeId => {
        defaultValue.push([storeId, giftCardTypeId]);
      });
    } else {
      // If no gift card type IDs, add only the store ID
      defaultValue.push([storeId]);
    }
  });

  return defaultValue;
}
